import React from "react";
import { DropdownAtRoot } from "components/basic/Dropdown";
import { TimeOption } from "model/Datatypes";
import LoadingIcon from "components/basic/LoadingIcon/LoadingIcon";

interface Props {
  timeSelected?: TimeOption;
  timeOptions?: TimeOption[];
  onNewTimeSelected?: (newTime: TimeOption) => void;
  customFoot?: React.ReactNode;
  loading?: boolean;
  size?: "full" | "56" | "48";
  flipdropdown?: true;
  graphTitle?: string;
}

const TouchCard: React.FC<Props> = ({
  children,
  timeSelected,
  timeOptions,
  onNewTimeSelected,
  loading,
  size,
  customFoot,
  flipdropdown,
  graphTitle,
}) => {
  return (
    <div
      className={`rounded  w-full border border-gray-300 bg-white text-gray-700 flex flex-col text-xs shadow-xxl relative pb-12 overflow-hidden ${
        size === "full" ? "h-full" : size === "48" ? "h-48" : "h-56"
      }`}
    >
      <div className={`relative h-full`}>
        <div>
          {graphTitle && (
            <div className="text-lg text-gray-600 font-medium ml-4 mt-3">{graphTitle}</div>
          )}
        </div>
        {children}

        {loading && (
          <div
            className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white opacity-75 text-gray-700"
            style={{ fontSize: "4rem" }}
          >
            <LoadingIcon />
          </div>
        )}
      </div>
      <div className="absolute bottom-0 left-0 w-full bg-gray-100 flex items-center h-12 justify-between px-4 border-t z-20 ">
        {timeOptions && onNewTimeSelected && (
          <div className="text-gray-600 -ml-2">
            <DropdownAtRoot
              options={timeOptions.map((to) => ({ id: to.id, display: to.display, val: to }))}
              onSelect={(option) => {
                onNewTimeSelected(option.val);
              }}
              selectedID={timeSelected?.id}
              flipped={flipdropdown}
            />
          </div>
        )}
        {customFoot && !timeOptions && customFoot}
      </div>
    </div>
  );
};

export default TouchCard;
